import { Query } from '@apollo/client/react/components';
import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { VirtualConnectionQuery, VirtualConnectionQueryVariables, VirtualConnectionDocument } from '../../../../../gen-src/queries';
import {
  CenteredFadeInSpinner,
  CenteredMessage,
} from '../../../data-catalog-shared';
import { RenderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

export type VirtualConnectionQueryWrapperProps = {
  readonly vizportalUrlId: string;
  readonly children: (result: Unpacked<VirtualConnectionQuery['virtualConnections']>) => React.ReactNode;
};

export class VirtualConnectionQueryWrapper extends React.Component<VirtualConnectionQueryWrapperProps> {

  public override render(): React.ReactNode {
    return (
      <Query<VirtualConnectionQuery, VirtualConnectionQueryVariables>
        query={VirtualConnectionDocument}
        variables={{ vizportalUrlId: this.props.vizportalUrlId }}
      >
        {result => <RenderQueryResult result={result} renderers={{
          renderLoading: () => <CenteredFadeInSpinner />,
          renderData: this.renderVirtualConnectionData,
          renderNoData: renderNoData,
          renderDataWithError: createRenderDataWithErrorFunction(this.renderVirtualConnectionData),
          renderError: renderError,
        }} />}
      </Query>
    );
  }

  private readonly renderVirtualConnectionData = (data: VirtualConnectionQuery): React.ReactNode => {
    const virtualConnection = data.virtualConnections ? data.virtualConnections[0] : null;
    if (virtualConnection) {
      return this.props.children(virtualConnection);
    } else {
      return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
    }
  }

}
